import APITemplate from './APITemplate'

const url = '/tracking-device'
const template = APITemplate(url)

export default {
  ...template,
  getFirmwares () {
    return fetch('/firmware', {
      method: 'GET',
      credentials: 'include',
      redirect: 'error',
      headers: template.headers
    }).then(template.errorHandler)
  }
}
